import classNames from 'classnames'

import './skeleton.css'

export interface SkeletonProps {
    /** CSS width (number → px). Defaults to 100%. */
    width?: string | number
    /** CSS height (number → px). Defaults to 16px. */
    height?: string | number
    /** Border radius (number → px). Defaults to 6px. */
    radius?: string | number
    /** Number of stacked bars to render. Defaults to 1. */
    count?: number
    className?: string
}

const toCss = (value: string | number | undefined): string | undefined =>
    typeof value === 'number' ? `${value}px` : value

/**
 * Layout-agnostic shimmer placeholder. Render one or more bars sized to mirror
 * the content they stand in for, instead of a centred spinner.
 */
export const Skeleton = ({ width, height, radius, count = 1, className }: SkeletonProps) => {
    const style = {
        width: toCss(width),
        height: toCss(height),
        borderRadius: toCss(radius),
    }
    return (
        <>
            {Array.from({ length: count }, (_, i) => (
                <span key={i} className={classNames('skeleton', className)} style={style} />
            ))}
        </>
    )
}
